var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2776 14.659L14.6813 24.2553C13.2365 25.7002 13.2365 28.0442 14.6813 29.489V29.489C16.1262 30.9339 18.4702 30.9339 19.915 29.489L32.5655 16.8386C35.2156 14.1885 35.2156 9.89236 32.5655 7.24227V7.24227C29.9154 4.59218 25.6193 4.59218 22.9692 7.24227L10.3187 19.8927C6.46342 23.7481 6.46342 29.9963 10.3187 33.8516V33.8516C14.174 37.707 20.4223 37.707 24.2776 33.8516L31.955 26.1742",
    stroke: "#000E08",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachment);
export default __webpack_public_path__ + "static/media/icon_attachment.5df240764763ecf3c8c92db2705b62e1.svg";
export { ForwardRef as ReactComponent };